// Webs del Camino (de Ciganda) a las que enlaza la app: se enlazan, no se duplican (alcance v1).
export const VISIT_URL = 'https://visitcaminoveracruz.com/'
export const REFORESTATION_URL = 'https://reforestacioncaminoveracruz.com/'
